import { useUpdateProfile } from '@lista/app-core';
import { useTranslation } from 'react-i18next';
import { useSession } from '../auth/session-store';
import { applyTheme, effectiveTheme, useTheme } from '../lib/theme';
import { Icon } from '../ui';

/**
 * Top-bar light/dark switch. Shows the theme it switches to (moon in light mode, sun in dark
 * mode); signed in, the choice is also saved to the profile like the Settings page does.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const signedIn = useSession((s) => s.status === 'authenticated');
  const update = useUpdateProfile();
  const next = effectiveTheme(useTheme()) === 'DARK' ? 'LIGHT' : 'DARK';
  return (
    <button
      type="button"
      className={className}
      aria-label={t(next === 'DARK' ? 'settings.switchToDark' : 'settings.switchToLight')}
      title={t(next === 'DARK' ? 'settings.switchToDark' : 'settings.switchToLight')}
      onClick={() => {
        applyTheme(next);
        if (signedIn) update.mutate({ theme: next });
      }}
    >
      <Icon name={next === 'DARK' ? 'moon' : 'sun'} />
    </button>
  );
}
